export const ORDER_STATUS_CLOSED_SELL = {
  message: 'This market is now closed for selling orders.',
  status: 'ERROR',
  success: true,
  closedMarket: true,
};

export const ORDER_STATUS_CLOSED_CANCEL = {
  message: 'This market is now closed for cancelling orders.',
  status: 'ERROR',
  success: true,
  closedMarket: true,
};
